var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{attrs:{"to":{ name: 'tagContent', params: { tag: _vm.tag.fields.name }}}},[_vm._v(_vm._s(_vm.tag.fields.name))]),_vm._v(",\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }